import { render, staticRenderFns } from "./OrderDetailWidgetClient.vue?vue&type=template&id=8924a3dc&scoped=true&"
import script from "./OrderDetailWidgetClient.vue?vue&type=script&lang=js&"
export * from "./OrderDetailWidgetClient.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailWidgetClient.vue?vue&type=style&index=0&id=8924a3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8924a3dc",
  null
  
)

export default component.exports